import { INFO_URL } from "../config/config";
import { HealthCheckInfo } from "../models/HealthCheckInfo";

export const getInfo = () => {
    return fetch(INFO_URL).then(result => result.json()).then(result => result as HealthCheckInfo[] || []);
};
